export const environment = {
    production: true,
    version: '1.3.0',
    // Local
    localApiUrl: 'http://localhost:8000',
    // QA
    apiUrl: 'https://services.wegoshare.com/v3', 
    apiKey: '164b6395-785c-41f2-b52c-582310b2c6fa',
    webSocket: 'wss://services.wegoshare.com/v3/busdata/ws',
    monitoring: [
        {"platform": "1", "kuma": "QTvMBRa76M"},
        {"platform": "2", "kuma": "EqYgycHbX2"},
        {"platform": "3", "kuma": "3PgBjJqTNX"},
        {"platform": "4", "kuma": "yAMzqnGi3r"},
        {"platform": "5", "kuma": "WtmeW2eU7d"},
        {"platform": "6", "kuma": "9p4v0BBoK6"},
        {"platform": "7", "kuma": "31uoxBCfyz"},
        {"platform": "8", "kuma": "TiRIpCOTlA"},
        {"platform": "9", "kuma": "Rr2ySKQXuW"},
        {"platform": "10", "kuma": "b9zDUd5bqL"},
        {"platform": "11", "kuma": "3KyKGfFV8Z"},
        {"platform": "12", "kuma": "Pw9OtktkHx"},
        {"platform": "13", "kuma": "cpt9G458aH"},
        {"platform": "14", "kuma": "zM9B3bN4et"},
        {"platform": "15", "kuma": "dsNmHszxjV"},
        {"platform": "16", "kuma": "vOp2Yuln9A"},
        {"platform": "17", "kuma": "Dt1gVNkWdI"},
        {"platform": "18", "kuma": "B87iVWf9Qr"},
        {"platform": "19", "kuma": "Y9UTsJhJWp"},
        {"platform": "20", "kuma": "VOt1PQ8ALz"},
        {"platform": "21", "kuma": "Tr8LFhkD8a"},
        {"platform": "22", "kuma": "AiRv0Fkbid"},
        {"platform": "23", "kuma": "Ep3vhvgwIq"},
        {"platform": "kiosk", "kuma": "jd31gAPT1f"}
    ],
    //Configuration
    numberOfButtons: 4,
    buttonsNames: ['Botão TUB', 'Botão WC', 'Botão Cais 12', 'Botão Cais 19'],
    buttonsIdentifiers: ['E66130100F3A9C2B', 'E663B035971F9723', 'E6614103E74E7E37', 'E6647C15677B2430'],
    alertTimeMin: 5,
    clockButton: false
};
